import InstructionIcon from 'assets/img/icons/instruction.svg';
import Button from 'components/_parts/atoms/button';
import Input from 'components/_parts/atoms/input';
import Label from 'components/_parts/atoms/label';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch } from 'react-redux';
import {
  HIT_WORKER_TYPE_CREATE,
  HIT_WORKER_TYPE_UPDATE,
} from 'redux/actions/wla';
import styled from 'styled-components';
import * as Yup from 'yup';
import './index.scss';
import Dummy from '../dummy';

const FullScreenOverlay = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  right: 0;
  right: 0;
  top: 0;
`;

const ButtonMod = styled(Button)`
  width: 100%;
  width: 92px;
  height: 40px;
  float: right;
`;
const ButtonInfo = styled(Button)`
  width: 100%;
  width: fit-content;
  height: 40px;
  min-width: 147px;
  border: 1px solid #3d5afe;
  background-color: #ffffff;
  color: #3d5afe;
  padding: 12px 16px;
  column-gap: 10px;
`;

function WorkerType(props) {
  const dispatch = useDispatch();
  const { t } = props;
  const { dataUnit } = Dummy(t);
  const [unitType, setUnitType] = useState('hour');
  const convertToMinutes = (item, type) => {
    if (type === 'minute') {
      return item * 60;
    }
    return item;
  };
  const convertToHour = (item, type) => {
    if (type === 'minute') {
      return `${item / 60}`;
    }
    return `${item}`;
  };
  const formik = useFormik({
    initialValues: {
      worker_type_name: '',
      satu_hari_kerja: '',
      hari_kerja_perminggu: '',
      harian: '',
      mingguan: '',
      bulanan: '',
      tahunan: '',
      total: '',
      satuan: props?.dataWorkerType?.satuan ?? '',
    },
    validationSchema: Yup.object().shape({
      worker_type_name: Yup.string()
        .typeError('Field must be string !')
        .required(t('general.message.field_required')),
      satu_hari_kerja: Yup.string()
        .typeError('Field must be string !')
        .required(t('general.message.field_required')),
      hari_kerja_perminggu: Yup.string()
        .typeError('Field must be string !')
        .required(t('general.message.field_required')),
      harian: Yup.string()
        .typeError('Field must be string !')
        .required(t('general.message.field_required')),
      mingguan: Yup.string()
        .typeError('Field must be string !')
        .required(t('general.message.field_required')),
      bulanan: Yup.string()
        .typeError('Field must be string !')
        .required(t('general.message.field_required')),
      tahunan: Yup.string()
        .typeError('Field must be string !')
        .required(t('general.message.field_required')),
      total: Yup.string()
        .typeError('Field must be string !')
        .required(t('general.message.field_required')),
    }),
    onSubmit: async (values) => {
      try {
        values.total = convertToHour(values.total, formik.values.satuan);

        if (props.typeForm === 'edit') {
          dispatch({
            type: HIT_WORKER_TYPE_UPDATE,
            payload: {
              data: values,
              id: props.ids,
            },
          });
        } else {
          dispatch({
            type: HIT_WORKER_TYPE_CREATE,
            payload: values,
          });
        }
        props.funcModal(false);
        formik.resetForm();
      } catch (error) {
        props.funcModal(false);
        formik.resetForm();
      }
    },
    onChange: (e) => {
      formik.setFieldValue(e.target.name, e.target.value);
    },
  });

  useEffect(() => {
    if (props.typeForm === 'edit') {
      formik.setValues({
        worker_type_name: props.dataWorkerType?.worker_type_name,
        worker_type_id: props.dataWorkerType?.worker_type_id || '',
        satu_hari_kerja: props.dataWorkerType?.satu_hari_kerja,
        hari_kerja_perminggu: props.dataWorkerType?.hari_kerja_perminggu,
        harian: props.dataWorkerType?.harian,
        mingguan: props.dataWorkerType?.mingguan,
        bulanan: props.dataWorkerType?.bulanan,
        tahunan: props.dataWorkerType?.tahunan,
        total: convertToMinutes(props.dataWorkerType?.total, formik.values.satuan),
        // total: props.dataWorkerType?.total,
        satuan: props.dataWorkerType?.satuan,
      });
    } else {
      formik.setValues({
        worker_type_name: '',
        worker_type_id: '',
        satu_hari_kerja: '',
        hari_kerja_perminggu: '',
        harian: '',
        mingguan: '',
        bulanan: '',
        tahunan: '',
        total: '',
        satuan: 'hour',
      });
    }
  }, [props.typeForm, props.dataWorkerType, props?.ids, props?.modal]);

  useEffect(() => {
    if (props.showModal) {
      formik.resetForm();
    }
  }, [props.showModal]);

  useEffect(() => {
    if (formik.values.satuan === 'minute' && formik.values.total !== '') {
      formik.setFieldValue('total', convertToMinutes(formik.values.total, formik.values.satuan));
    } else if (formik.values.satuan === 'hour' && formik.values.total !== '') {
      formik.setFieldValue('total', formik.values.total / 60);
    }
  }, [formik.values.satuan]);


  return (
    <div>
      {props.modal
        && createPortal(
          <>
            <FullScreenOverlay className="cs_modal-bg" />
            <div
              className="cs_modal-container d-flex justify-content-between flex-column"
              ref={props.innerRef}
            >
              <Label
                className="text-center"
                typeLabel="label_modal"
                style={{
                  fontSize: '16px',
                }}
              >
                {`${props?.typeForm === 'edit' ? t('org.structure_view.modal.edit') : t('org.structure_view.modal.add')} ${t('org.structure_view.worker_type_name')}`}
              </Label>
              <div className="cs_modal-worktype">
                <div>
                  <Input
                    className="text-center w-100"
                    isError={
                      formik.touched.worker_type_name
                      && Boolean(formik.errors.worker_type_name)
                    }
                    validateMessage={formik.errors.worker_type_name}
                    type="text"
                    name="worker_type_name"
                    placeholder={t('company.worker_type_name')}
                    value={formik.values.worker_type_name}
                    onChange={formik.handleChange}
                  />
                </div>
                <div>
                  <Input
                    value={dataUnit.filter((val) => formik.values.satuan?.includes(val.value))}
                    type="dropdown-windowed"
                    name="worker_type_unit"
                    placeholder={t('workload_landing.unit')}
                    options={dataUnit}
                    onChange={(e) => {
                      formik.setFieldValue('satuan', e.value);
                    }}
                    hideIcon
                  />
                </div>
                <div>
                  <Input
                    className="text-center w-100"
                    isError={
                      formik.touched.satu_hari_kerja
                      && Boolean(formik.errors.satu_hari_kerja)
                    }
                    validateMessage={formik.errors.satu_hari_kerja}
                    type="text"
                    name="satu_hari_kerja"
                    placeholder={t('company.one_working_day')}
                    value={formik.values.satu_hari_kerja}
                    onChange={formik.handleChange}
                  />
                </div>
                <div>
                  <Input
                    className="text-center w-100"
                    isError={
                      formik.touched.hari_kerja_perminggu
                      && Boolean(formik.errors.hari_kerja_perminggu)
                    }
                    validateMessage={formik.errors.hari_kerja_perminggu}
                    type="text"
                    name="hari_kerja_perminggu"
                    placeholder={t('company.days_per_weeks')}
                    value={formik.values.hari_kerja_perminggu}
                    onChange={formik.handleChange}
                    style={{
                      padding: '6px 6px',
                    }}
                  />
                </div>
                <div>
                  <Input
                    className="text-center w-100"
                    isError={
                      formik.touched.harian && Boolean(formik.errors.harian)
                    }
                    validateMessage={formik.errors.harian}
                    type="text"
                    name="harian"
                    placeholder={t('company.daily')}
                    value={formik.values.harian}
                    onChange={formik.handleChange}
                  />
                </div>
                <div>
                  <Input
                    className="text-center w-100"
                    isError={
                      formik.touched.mingguan && Boolean(formik.errors.mingguan)
                    }
                    validateMessage={formik.errors.mingguan}
                    type="text"
                    name="mingguan"
                    placeholder={t('company.weekly')}
                    value={formik.values.mingguan}
                    onChange={formik.handleChange}
                  />
                </div>
                <div>
                  <Input
                    className="text-center w-100"
                    isError={
                      formik.touched.bulanan && Boolean(formik.errors.bulanan)
                    }
                    validateMessage={formik.errors.bulanan}
                    type="text"
                    name="bulanan"
                    placeholder={t('company.mounthly')}
                    value={formik.values.bulanan}
                    onChange={formik.handleChange}
                  />
                </div>
                <div>
                  <Input
                    className="text-center w-100"
                    isError={
                      formik.touched.tahunan && Boolean(formik.errors.tahunan)
                    }
                    validateMessage={formik.errors.tahunan}
                    type="text"
                    name="tahunan"
                    placeholder={t('company.yearly')}
                    value={formik.values.tahunan}
                    onChange={formik.handleChange}
                  />
                </div>
                <div>
                  <Input
                    className="text-center w-100"
                    isError={
                      formik.touched.total && Boolean(formik.errors.total)
                    }
                    validateMessage={formik.errors.total}
                    type="text"
                    name="total"
                    placeholder={t('company.total_availabel')}
                    value={formik.values.total}
                    onChange={formik.handleChange}
                  />
                </div>
              </div>
              <div className="d-flex flex-row justify-content-between">
                <ButtonInfo disabled>
                  <span>
                    <img src={InstructionIcon} alt="" />
                  </span>
                  {t('company.fill_instruction')}
                </ButtonInfo>
                <ButtonMod
                  func={(e) => {
                    formik.handleSubmit(e);
                    setTimeout(() => {
                      props.funcId(null);
                    }, 1000);
                  }}
                >
                  {t('board.save')}
                </ButtonMod>
              </div>
            </div>
          </>,
          document.getElementById('worker_type_list'),
        )}
    </div>
  );
}

export default WorkerType;
